/**
 * 成果物フォルダ（デザイン成果物を置く Google Drive フォルダ）の契約（path・型）。
 *
 * 案件仕様書の「成果物」ボタン（GAS `createDeliverableFolders`）を cortex へ移したもの。
 * PI Lab の案件詳細画面と mcp-project-management が**同じ path と型を引く**ために、
 * サービス間契約のこのパッケージに置く（`apps/` 間の直接 import は不可）。
 *
 * 成果物種別の一覧（id・表示名・Drive 上のフォルダ名）はここに置かない。種別は product-api
 * だけが持ち、`GET` で返す。画面と MCP はその一覧を出して選ばせるだけにする（入口に写すと、
 * 種別を足したときに黙ってずれる）。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 成果物フォルダの一覧・作成で product-api / Web / MCP が共有する path と型
 * @graph-connects none
 */
/**
 * 成果物フォルダの path（GET = 種別ごとの現状 / POST = 作成）。対象は母票（親チケット）。
 * @graph-connects none
 */
export function projectDeliverableFoldersPath(issueKey) {
    return `/projects/${encodeURIComponent(issueKey)}/deliverable-folders`;
}
/** 全値（レスポンス schema の enum に使う）。 @graph-connects none */
export const DELIVERABLE_FOLDER_OUTCOMES = [
    'created',
    'exists',
    'failed',
];
/** 全値（レスポンス schema の enum に使う）。 @graph-connects none */
export const DELIVERABLE_FOLDERS_SLACK_STATUSES = [
    'posted',
    'skipped',
    'no_channel',
    'failed',
];
//# sourceMappingURL=project-deliverable-folders.js.map